<template>
  <div class="container--large">
    <h2 class="node--my-account__form__heading">Redigera din profil</h2>
    <p v-if="updateSuccess" class="node--my-account__form__success-message">
      Kontouppgifter uppdaterade
    </p>
    <form
      @submit.prevent="handleSubmit"
      class="node--my-account__form__account-type"
    >
      <div class="node--my-account__form__account__input-background">
        <div class="node--my-account__form_account__input-wrapper">
          <label class="node--my-account__form_account__label-row">
            Förnamn
            <input
              required
              v-model="accountInfoFirstName"
              type="text"
              class="node--my-account__form__account__type-input"
              placeholder="Stockholm"
            />
          </label>
          <label class="node--my-account__form_account__label-row">
            Efternamn
            <input
              required
              v-model="accountInfoLastName"
              type="text"
              class="node--my-account__form__account__type-input"
              placeholder="Stockholm"
            />
          </label>
        </div>
        <label class="node--my-account__form_account__label-row">
          E-post
          <input
            required
            v-model="accountInfoMail"
            type="email"
            class="node--my-account__form__account__type-input"
            placeholder="123 45"
          />
        </label>
        <label class="node--my-account__form_account__label-row">
          Adress
          <input
            required
            v-model="accountInfoAddress"
            type="text"
            class="node--my-account__form__account__type-input"
            placeholder="Stockholm"
          />
        </label>
        <div class="node--my-account__form_account__input-wrapper">
          <label class="node--my-account__form_account__label-row">
            Postnummer
            <input
              required
              v-model="accountInfoPostalCode"
              type="text"
              pattern="\d{3}[ ]?\d{2}"
              class="node--my-account__form__account__type-input"
              placeholder="123 45"
            />
          </label>
          <label class="node--my-account__form_account__label-row">
            Stad
            <input
              required
              v-model="accountInfoCity"
              type="text"
              class="node--my-account__form__account__type-input"
              placeholder="Stockholm"
            />
          </label>
        </div>
        <label class="node--my-account__form_account-label">
          Land
          <select
            class="node--my-account__form__account__type-input"
            v-model="accountInfoCountry"
            id=""
          >
            <option value="SE">Sweden</option>
            <option value="DK">Denmark</option>
            <option value="NO">Norway</option>
            <option value="FI">Finland</option>
            <option value="IS">Iceland</option>
          </select>
        </label>
        <label class="node--my-account__form_account-label">
          Telefon
          <input
            required
            v-model="accountInfoPhone"
            type="number"
            class="node--my-account__form__account__type-input"
            placeholder="Sverige"
          />
        </label>
      </div>

      <div class="node--my-account__form__button-wrapper-account-settings">
        <button
          class="node--my-account__form__button-next"
          id="nextButton"
          type="submit"
        >
          Spara
        </button>
      </div>
    </form>

    <!-- INTERN SCHOOL FORM -->
    <template v-if="isInternalSchoolUser">
      <h2 class="node--my-account__form__heading">Faktureringsuppgifter</h2>
      <p
        v-if="invoiceUpdateSuccess"
        class="node--my-account__form__success-message"
      >
        Dina faktureringsuppgifter har uppdaterats
      </p>
      <form
        @submit.prevent="handleInvoiceSubmit"
        class="node--my-account__form__account-type"
      >
        <div class="node--my-account__form__account__input-background">
          <label class="node--my-account__form_account-label">
            Skola *
            <input
              required
              v-model="orgName"
              type="text"
              class="node--my-account__form__account__type-input"
              placeholder="Organisation AB"
            />
          </label>
          <label class="node--my-account__form_account-label">
            Förvaltningskod
            <input
              required
              v-model="customerId"
              type="text"
              class="node--my-account__form__account__type-input"
              placeholder="STH123"
            />
          </label>
          <label class="node--my-account__form_account-label">
            Referensnummer
            <input
              required
              v-model="yourReferenceSchool"
              type="number"
              class="node--my-account__form__account__type-input"
              placeholder="Referensnummer"
            />
          </label>
        </div>
        <div class="node--my-account__form__button-wrapper-account-settings">
          <button
            class="node--my-account__form__button-next"
            id="nextButton"
            type="submit"
          >
            Spara
          </button>
        </div>
      </form>
    </template>
    <!-- INTERN FORM SCHOOL END -->

    <!-- EXTERNA FORM -->
    <template v-else-if="isExternalSchoolUser || isExternalCompanyUser">
      <h2 class="node--my-account__form__heading">Faktureringsuppgifter</h2>
      <p
        v-if="invoiceUpdateSuccess"
        class="node--my-account__form__success-message"
      >
        Dina faktureringsuppgifter har uppdaterats
      </p>
      <form
        @submit.prevent="handleInvoiceSubmit"
        class="node--my-account__form__account-type"
      >
        <div class="node--my-account__form__account__input-background">
          <template v-if="isExternalCompanyUser || isExternalSchoolUser">
            <label class="node--my-account__form_account-label">
              <template v-if="isExternalCompanyUser">
                Organisationsnamn *
              </template>
              <template v-else>Skolenhetskod *</template>
              <input
                required
                v-model="orgValue"
                @blur="getOrgInfo"
                :type="isExternalSchoolUser ? 'number' : 'text'"
                class="node--my-account__form__account__type-input"
                placeholder="Organisation AB"
              />
            </label>
            <label v-if="isExternalSchoolUser" class="node--my-account__form_account-label">
              Skolnamn
              <input
                v-model="orgName"
                type="text"
                class="node--my-account__form__account__type-input"
                placeholder="Skolans namn"
                disabled
              />
            </label>
            <label class="node--my-account__form_account-label">
              Kund-id (STHXXX) *
              <input
                required
                v-model="customerId"
                type="text"
                class="node--my-account__form__account__type-input"
                placeholder="STH123"
              />
            </label>
            <label class="node--my-account__form_account-label">
              Adress *
              <input
                required
                v-model="orgAddress"
                type="text"
                class="node--my-account__form__account__type-input"
                placeholder="Exempelvägen 1"
              />
            </label>
            <div class="node--my-account__form_account__input-wrapper">
              <label class="node--my-account__form_account__label-row">
                Postnummer *
                <input
                  required
                  v-model="orgPostalCode"
                  type="text"
                  pattern="\d{3}[ ]?\d{2}"
                  class="node--my-account__form__account__type-input"
                  placeholder="123 45"
                />
              </label>
              <label class="node--my-account__form_account__label-row">
                Ort *
                <input
                  required
                  v-model="orgCity"
                  type="text"
                  class="node--my-account__form__account__type-input"
                  placeholder="Stockholm"
                />
              </label>
            </div>
            <label class="node--my-account__form_account-label">
              Land *
              <input
                required
                v-model="orgCountry"
                type="text"
                class="node--my-account__form__account__type-input"
                placeholder="Sverige"
              />
            </label>
            <label class="node--my-account__form_account-label">
              Namn på faktura
              <input
                required
                v-model="nameOnInvoice"
                type="text"
                class="node--my-account__form__account__type-input"
                placeholder="Förnamn Efternamn"
              />
            </label>
            <label class="node--my-account__form_account-label">
              E-post för digital faktura *
              <input
                required
                v-model="digitalInvoiceEmail"
                type="email"
                class="node--my-account__form__account__type-input"
                placeholder="exempel@exempel.com"
              />
            </label>
            <label class="node--my-account__form_account-label">
              Er referens *
              <input
                required
                v-model="yourReference"
                type="text"
                class="node--my-account__form__account__type-input"
                placeholder="Referens"
              />
            </label>
          </template>
        </div>
        <div class="node--my-account__form__button-wrapper-account-settings">
          <button
            class="node--my-account__form__button-next"
            id="nextButton"
            type="submit"
          >
            Spara
          </button>
        </div>
      </form>
    </template>
    <!-- EXTERNAL FORM END -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AccountUpdateBlock",
  components: {},
  data() {
    return { updateSuccess: false, invoiceUpdateSuccess: false };
  },
  methods: {
    ...mapActions([
      "getAccountInfo",
      "setFormData",
      "updateAccountInfo",
      "updateInvoiceInfo",
      "getExternalInfo",
    ]),
    getOrgInfo() {
      const trimmedValue = String(this.orgValue).replace(/\D/g, "").trim();
      if (!trimmedValue) return;
      if (this.isExternalSchoolUser) {
        this.setFormData({ accountType: "school" });
      }
      this.getExternalInfo(trimmedValue);
    },
    async handleSubmit() {
      const countryMap = {
        SE: "Sverige",
        DK: "Danmark",
        NO: "Norge",
        FI: "Finland",
        IS: "Island",
      };
      const accountData = {
        Email: this.formData.accountInfoMail,
        FirstName: this.formData.accountInfoFirstName,
        LastName: this.formData.accountInfoLastName,
        Name: `${this.formData.accountInfoFirstName} ${this.formData.accountInfoLastName}`.trim(),
        AddressOne: this.formData.accountInfoAddress,
        InvoiceAddress: this.formData.customerId,
        ZipCode: this.formData.accountInfoPostalCode,
        Country: countryMap[this.formData.accountInfoCountry],
        CountryCode: this.formData.accountInfoCountry,
        City: this.formData.accountInfoCity,
        Mobile: this.formData.accountInfoPhone,
      };
      await this.updateAccountInfo(accountData);

      // Set a updateSuccess message, and scrolls to top once
      // you have clicked on the save button
      this.updateSuccess = true;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    async handleInvoiceSubmit() {
      let invoiceData = {};
      if (this.isExternalCompanyUser || this.isExternalSchoolUser) {
        invoiceData = {
          CompanyName: this.orgName,
          Metadata: [
            {
              Name: "InvoiceAddress",
              Value: this.customerId,
              CustomerAttributeID: 12,
            },
            {
              Name: "InvoiceAddressTwo",
              Value: this.orgAddress,
              CustomerAttributeID: 13,
            },
            {
              Name: "InvoiceZip",
              Value: this.orgPostalCode,
              CustomerAttributeID: 14,
            },
            {
              Name: "InvoiceCity",
              Value: this.orgCity,
              CustomerAttributeID: 15,
            },
            {
              Name: "InvoiceCountry",
              Value: this.orgCountry,
              CustomerAttributeID: 16,
            },
            {
              Name: "InvoiceRefNo1",
              Value: this.yourReference,
              CustomerAttributeID: 17,
            },
            {
              Name: "InvoiceEmail",
              Value: this.digitalInvoiceEmail,
              CustomerAttributeID: 19,
            },
            {
              Name: "InvoiceName",
              Value: this.nameOnInvoice,
              CustomerAttributeID: 22,
            },
          ],
        };
      } else if (this.isInternalSchoolUser) {
        invoiceData = {
          CompanyName: this.orgName,
          Metadata: [
            {
              Name: "InvoiceAddressOne",
              Value: this.customerId,
              CustomerAttributeID: 12,
            },
            {
              Name: "InvoiceRefNo2",
              Value: this.yourReferenceSchool,
              CustomerAttributeID: 18,
            },
          ],
        };
      }
      await this.updateInvoiceInfo(invoiceData);

      // Show success message
      this.invoiceUpdateSuccess = true;

      // Scroll to top of form
      window.scrollTo({
        top: this.$el.offsetTop,
        behavior: "smooth",
      });
    },
  },
  computed: {
    ...mapGetters({
      formData: "getFormData",
      accountTypeID: "getAccountTypeID",
    }),
    accountInfoFirstName: {
      get() {
        return this.formData.accountInfoFirstName || "";
      },
      set(value) {
        this.setFormData({ accountInfoFirstName: value });
      },
    },
    accountInfoLastName: {
      get() {
        return this.formData.accountInfoLastName || "";
      },
      set(value) {
        this.setFormData({ accountInfoLastName: value });
      },
    },
    accountInfoMail: {
      get() {
        return this.formData.accountInfoMail || "";
      },
      set(value) {
        this.setFormData({ accountInfoMail: value });
      },
    },
    accountInfoAddress: {
      get() {
        return this.formData.accountInfoAddress || "";
      },
      set(value) {
        this.setFormData({ accountInfoAddress: value });
      },
    },
    accountInfoPostalCode: {
      get() {
        return this.formData.accountInfoPostalCode || "";
      },
      set(value) {
        this.setFormData({ accountInfoPostalCode: value });
      },
    },
    accountInfoCity: {
      get() {
        return this.formData.accountInfoCity || "";
      },
      set(value) {
        this.setFormData({ accountInfoCity: value });
      },
    },
    accountInfoCountry: {
      get() {
        return this.formData.accountInfoCountry || "";
      },
      set(value) {
        this.setFormData({ accountInfoCountry: value });
      },
    },
    accountInfoPhone: {
      get() {
        return this.formData.accountInfoPhone || "";
      },
      set(value) {
        this.setFormData({ accountInfoPhone: value });
      },
    },
    customerId: {
      get() {
        return this.formData.customerId || "";
      },
      set(value) {
        this.setFormData({ customerId: value });
      },
    },
    orgValue: {
      get() {
        return this.formData.orgValue || "";
      },
      set(value) {
        this.setFormData({ orgValue: value });
      },
    },
    orgName: {
      get() {
        return this.formData.orgName || "";
      },
      set(value) {
        this.setFormData({ orgName: value });
      },
    },
    orgAddress: {
      get() {
        return this.formData.orgAddress || "";
      },
      set(value) {
        this.setFormData({ orgAddress: value });
      },
    },
    orgPostalCode: {
      get() {
        return this.formData.orgPostalCode || "";
      },
      set(value) {
        this.setFormData({ orgPostalCode: value });
      },
    },
    orgCity: {
      get() {
        return this.formData.orgCity || "";
      },
      set(value) {
        this.setFormData({ orgCity: value });
      },
    },
    orgCountry: {
      get() {
        return this.formData.orgCountry || "";
      },
      set(value) {
        this.setFormData({ orgCountry: value });
      },
    },
    nameOnInvoice: {
      get() {
        return this.formData.nameOnInvoice || "";
      },
      set(value) {
        this.setFormData({ nameOnInvoice: value });
      },
    },
    digitalInvoiceEmail: {
      get() {
        return this.formData.digitalInvoiceEmail || "";
      },
      set(value) {
        this.setFormData({ digitalInvoiceEmail: value });
      },
    },
    yourReference: {
      get() {
        return this.formData.yourReference || "";
      },
      set(value) {
        this.setFormData({ yourReference: value });
      },
    },
    yourReferenceSchool: {
      get() {
        return this.formData.yourReferenceSchool || "";
      },
      set(value) {
        this.setFormData({ yourReferenceSchool: value });
      },
    },
    // isInternCompanyUser() {
    //   return (
    //     this.formData.userTags?.some((tag) => tag.Id === 251) &&
    //     this.formData.userTags?.some((tag) => tag.Id === 906)
    //   );
    // },
    isExternalCompanyUser() {
      return (
        this.formData.userTags?.some((tag) => tag.Id === 252) &&
        (this.formData.userTags?.some((tag) => tag.Id === 906) ||
          this.formData.userTags?.some((tag) => tag.Id === 901))
      );
    },
    isInternalSchoolUser() {
      return (
        this.formData.userTags?.some((tag) => tag.Id === 251) &&
        this.formData.userTags?.some((tag) => tag.Id === 907)
      );
    },
    isExternalSchoolUser() {
      return (
        (this.formData.userTags?.some((tag) => tag.Id === 252) &&
          this.formData.userTags?.some((tag) => tag.Id === 907)) ||
        (this.formData.userTags?.some((tag) => tag.Id === 252) &&
          this.formData.userTags?.some((tag) => tag.Id === 901))
      );
    },
  },
  async mounted() {
    await this.getAccountInfo();
  },
};
</script>

<style lang="scss" scoped>
.node--my-account__form__success-message {
  background-color: #dff0d8;
  color: #3c763d;
  padding: 1rem;
  margin-bottom: 1.25rem;
  border-radius: 4px;
  text-align: center;
}
</style>
